"use strict";

exports.__esModule = true;
// eslint-disable-next-line no-restricted-properties
var generateId = exports.generateId = function generateId() {
  return Math.round(Math.random() * Math.pow(10, 16));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-trend/lib/helpers/misc.helpers.js
// module id = 688
// module chunks = 0